let btnObj = {
  width: "120px",
  height: "32px",
  lineHeight: "32px",
  color: "#fff",
  fontSize: "14px",
  textAlign: "center",
  borderRadius: "4px",
  backgroundColor: "#666",
  float: "left",
  marginRight: "26px",
  cursor: "pointer",
};
const Css = {
  diaCss(obj){
    let res = {
      position: "absolute",
      margin: "30px auto",
      zIndex: 3,
    };
    return Object.assign({},res,obj);
  },
  txtDiv: {
    display: "inline-block",
    textAlign: "center",
    color: "#EAEAEA",
    margin: "30px 30px"
  },
  btnArea: {
    width: "100%",
    height: "32px",
    position: "absolute",
    bottom: "26px"
  },
  btn1(left){
    let obj = { ...btnObj };
    if(left){
      obj.marginLeft = left + "px";
    }
    return obj;
  },
  btn2(){
    let obj = { ...btnObj };
    obj.backgroundColor = "#ff2d89";
    return obj;
  },
}

export default Css;